import { clsx } from 'clsx';
import { ComponentProps, forwardRef } from 'react';

/**
 * `toolbar` istnieje dla paska narzędzi tabeli i tego, co pasek otwiera —
 * tam wszystko chodzi na 30 px / 12 px. Formularze zostają na `default`.
 */
export type PrimitiveInputSize = 'default' | 'toolbar';

const sizeClasses: Record<PrimitiveInputSize, string> = {
  default: 'px-3 py-1.5 text-sm',
  toolbar: 'px-2 py-1.5 text-xs',
};

export type PrimitiveInputProps = {
  error?: string;
  inputSize?: PrimitiveInputSize;
} & ComponentProps<'input'>;

const PrimitiveInput = forwardRef<HTMLInputElement, PrimitiveInputProps>(
  ({ error, className, disabled, inputSize = 'default', ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={clsx(
          'w-full rounded-md border bg-basic-white text-base-text',
          sizeClasses[inputSize],
          {
            'placeholder-neutral-300': !disabled,
            'bg-basic-disabled-bg text-basic-disabled-main placeholder-basic-disabled-main':
              disabled,
            'border-neutral-200': !error,
            'border-error-100': error,
          },
          className,
        )}
        disabled={disabled}
        {...props}
      />
    );
  },
);

PrimitiveInput.displayName = 'PrimitiveInput';

export default PrimitiveInput;
